import { forwardRef, ForwardRefExoticComponent, PropsWithoutRef, RefAttributes } from 'react';
import * as SDK from '@siloreal:shared:sdk';
import * as UI from '@siloreal:shared:ui';

type FR<T, P> = ForwardRefExoticComponent<PropsWithoutRef<P> & RefAttributes<T>>;

type Props = {
  tid: string;
  name: string;
  required?: boolean;
  label?: string;
  placeholder?: string;
  size?: 'medium' | 'large';
};

export const email: FR<HTMLInputElement, Props> = forwardRef((props, ref) => {
  const {
    name = 'email',
    label = 'Correo electrónico',
    placeholder = 'example@domain.com',
    ...restProps
  } = props;

  return (
    <UI.form.field.text
      name={name}
      label={label}
      placeholder={placeholder}
      {...restProps}
      ref={ref}
      type="email"
      validator={SDK.validator.form.email}
    />
  );
});

email.displayName = 'SiloReal-Form-Field-Email';
